export type SubscriptionTier = 'free' | 'trial' | 'yearly';

export interface PremiumFeature {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const PREMIUM_FEATURES: PremiumFeature[] = [
  {
    id: 'unlimited_products',
    name: 'Unbegrenzte Produkte',
    description: 'Füge so viele Produkte hinzu, wie du möchtest',
    icon: 'ListPlus'
  },
  {
    id: 'savings_goals',
    name: 'Sparziele',
    description: 'Setze dir Sparziele und verfolge deinen Fortschritt',
    icon: 'PiggyBank'
  },
  {
    id: 'price_history',
    name: 'Preisverlauf',
    description: 'Verfolge die Preisentwicklung deiner Produkte',
    icon: 'LineChart'
  },
  {
    id: 'pro_contra',
    name: 'Pro & Contra Listen',
    description: 'Erstelle Pro & Contra Listen für deine Kaufentscheidungen',
    icon: 'ListChecks'
  },
  {
    id: 'notes',
    name: 'Notizen',
    description: 'Füge Notizen zu deinen Produkten hinzu',
    icon: 'FileText'
  }
];

interface SubscriptionLimit {
  name: string;
  description: string;
  maxActiveProducts: number;
  price: number;
  features: string[];
}

export const SUBSCRIPTION_LIMITS: Record<SubscriptionTier, SubscriptionLimit> = {
  free: {
    name: 'Kostenlos',
    description: 'Basis-Funktionen für bis zu 1 Artikel',
    maxActiveProducts: 1,
    price: 0,
    features: []
  },
  trial: {
    name: '30 Tage Testlizenz',
    description: 'Teste alle Premium-Funktionen kostenlos',
    maxActiveProducts: Infinity,
    price: 0,
    features: PREMIUM_FEATURES.map(f => f.id)
  },
  yearly: {
    name: 'Jahres-Lizenz',
    description: 'Voller Zugriff mit jährlicher Zahlung - verlängert sich nicht automatisch',
    maxActiveProducts: Infinity,
    price: 16.90,
    features: PREMIUM_FEATURES.map(f => f.id)
  }
};

export interface Subscription {
  id: string;
  user_id: string;
  tier: SubscriptionTier;
  status: 'active' | 'cancelled' | 'expired';
  trial_end?: string;
  trial_used?: boolean;
  current_period_end: string;
  cancel_at_period_end: boolean;
  payment_method?: string;
  paypal_subscription_id?: string;
  premium_end_date?: string;
} 